(function () {
  var OPEN_HOUR = 9;
  var CLOSE_HOUR = 18;

  function getEasternNow() {
    var estString = new Date().toLocaleString('en-US', { timeZone: 'America/New_York' });
    return new Date(estString);
  }

  function formatTime(date) {
    return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
  }

  function formatDay(date) {
    return date.toLocaleDateString('en-US', { weekday: 'long' });
  }

  function nthWeekdayOfMonth(year, month, weekday, n) {
    var d = new Date(year, month, 1);
    var count = 0;
    while (true) {
      if (d.getDay() === weekday) {
        count++;
        if (count === n) return new Date(d);
      }
      d.setDate(d.getDate() + 1);
    }
  }

  function lastWeekdayOfMonth(year, month, weekday) {
    var d = new Date(year, month + 1, 0);
    while (d.getDay() !== weekday) {
      d.setDate(d.getDate() - 1);
    }
    return d;
  }

  function observedDate(date) {
    var d = new Date(date);
    if (d.getDay() === 6) d.setDate(d.getDate() - 1);
    else if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    return d;
  }

  function getFederalHolidays(year) {
    var holidays = [];
    holidays.push(observedDate(new Date(year, 0, 1)));
    holidays.push(nthWeekdayOfMonth(year, 0, 1, 3));
    holidays.push(nthWeekdayOfMonth(year, 1, 1, 3));
    holidays.push(lastWeekdayOfMonth(year, 4, 1));
    holidays.push(observedDate(new Date(year, 5, 19)));
    holidays.push(observedDate(new Date(year, 6, 4)));
    holidays.push(nthWeekdayOfMonth(year, 8, 1, 1));
    holidays.push(nthWeekdayOfMonth(year, 9, 1, 2));
    holidays.push(observedDate(new Date(year, 10, 11)));
    holidays.push(nthWeekdayOfMonth(year, 10, 4, 4));
    holidays.push(observedDate(new Date(year, 11, 25)));
    return holidays;
  }

  function isSameDate(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  }

  function isFederalHoliday(date) {
    var holidays = getFederalHolidays(date.getFullYear());
    for (var i = 0; i < holidays.length; i++) {
      if (isSameDate(date, holidays[i])) return true;
    }
    return false;
  }

  function isBusinessDay(date) {
    var day = date.getDay();
    return day >= 1 && day <= 5 && !isFederalHoliday(date);
  }

  // Finds the next date (starting tomorrow) that is an open business day
  function getNextOpenDate(fromDate) {
    var d = new Date(fromDate);
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + 1);
    var guard = 0;
    while (!isBusinessDay(d) && guard < 30) {
      d.setDate(d.getDate() + 1);
      guard++;
    }
    return d;
  }

  // Labels the next open date as "tomorrow", a weekday name, or a fallback date
  function formatNextOpenLabel(fromDate, nextOpenDate) {
    var oneDay = 24 * 60 * 60 * 1000;
    var fromMidnight = new Date(fromDate);
    fromMidnight.setHours(0, 0, 0, 0);
    var diffDays = Math.round((nextOpenDate - fromMidnight) / oneDay);

    if (diffDays === 1) return 'tomorrow';
    if (diffDays > 1 && diffDays <= 7) {
      return nextOpenDate.toLocaleDateString('en-US', { weekday: 'long' });
    }
    return nextOpenDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
  }

  function updateStatus() {
    var estNow = getEasternNow();
    var day = estNow.getDay();
    var hour = estNow.getHours();
    var lineEl = document.getElementById('support-status-line');
    var dayString = formatDay(estNow);
    var timeString = formatTime(estNow);

    var isWeekday = day >= 1 && day <= 5;
    var isHoliday = isFederalHoliday(estNow);
    var isBeforeOpen = isWeekday && !isHoliday && hour < OPEN_HOUR;
    var isOpen = isWeekday && !isHoliday && hour >= OPEN_HOUR && hour < CLOSE_HOUR;

    var sentence;
    if (isOpen) {
      sentence = "It's currently " + dayString + " at " + timeString + ", and we're open now. You can expect a response within a few hours.";
    } else if (isBeforeOpen) {
      sentence = "It's currently " + dayString + " at " + timeString + ", and we're closed for now, but we'll be back online later today. You can expect a response within a few hours.";
    } else {
      var reasonPhrase;
      if (!isWeekday) {
        reasonPhrase = 'for the weekend';
      } else if (isHoliday) {
        reasonPhrase = 'for a US federal holiday';
      } else {
        reasonPhrase = 'for the day';
      }

      var nextOpenDate = getNextOpenDate(estNow);
      var label = formatNextOpenLabel(estNow, nextOpenDate);
      var reopenPhrase = (label === 'tomorrow') ? "We'll reopen tomorrow" : ("We'll reopen on " + label);

      sentence = "It's " + dayString + " at " + timeString + ", and we're closed " + reasonPhrase + ". " + reopenPhrase + ", and you can expect a response within 1 business day.";
    }

    lineEl.textContent = sentence;
  }

  updateStatus();
  setInterval(updateStatus, 60000);
})();